// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bwoyg{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-brkhy{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bxyap{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bkpov{grid-column:span 3}.assets-scss-gridstyleGrid-col4-oogns{grid-column:span 4}.assets-scss-gridstyleGrid-col9-vjzjw{grid-column:span 9}.assets-scss-gridstyleGrid-col12-boiqm{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-wffia{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bwoyg",
	"grid": "assets-scss-gridstyleGrid-grid-brkhy",
	"col6": "assets-scss-gridstyleGrid-col6-bxyap",
	"col3": "assets-scss-gridstyleGrid-col3-bkpov",
	"col4": "assets-scss-gridstyleGrid-col4-oogns",
	"col9": "assets-scss-gridstyleGrid-col9-vjzjw",
	"col12": "assets-scss-gridstyleGrid-col12-boiqm",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-wffia"
};
module.exports = ___CSS_LOADER_EXPORT___;
